export default __webpack_public_path__ + "static/media/shangpin.a64ad0f4.png";